import React, { useState } from "react";
import { toast } from "sonner";

const KEY = "odcg_feedback_log";

export default function FeedbackModal({ open, onClose }) {
  const [stars, setStars] = useState(0);
  const [comment, setComment] = useState("");

  if (!open) return null;

  const save = () => {
    if (stars < 1) {
      toast.error("Pick a star rating.");
      return;
    }
    try {
      const prev = JSON.parse(localStorage.getItem(KEY) || "[]");
      prev.push({ at: new Date().toISOString(), stars, comment });
      localStorage.setItem(KEY, JSON.stringify(prev.slice(-50)));
      toast.success("Thanks — feedback saved locally.");
      setStars(0);
      setComment("");
      onClose();
    } catch {
      toast.error("Could not save feedback.");
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="fb-title">
      <button type="button" className="absolute inset-0 bg-black/40" aria-label="Close" onClick={onClose} />
      <div className="relative z-[101] w-full max-w-narrow rounded-ds-2xl border border-border bg-surface p-6 shadow-modal">
        <h2 id="fb-title" className="mb-2 text-xl font-bold text-fg">
          Rate this page
        </h2>
        <p className="mb-4 text-sm text-fg-secondary">1–5 stars and an optional comment (stored in this browser only).</p>
        <div className="mb-4 flex gap-1" role="radiogroup" aria-label="Star rating">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              aria-label={`${n} stars`}
              aria-pressed={stars === n}
              onClick={() => setStars(n)}
              className={`rounded-ds px-2 py-1 text-lg ${stars >= n ? "text-warning" : "text-fg-tertiary"} hover:bg-canvas-subtle`}
            >
              ★
            </button>
          ))}
        </div>
        <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="What could be clearer?" className="mb-4 w-full rounded-ds border border-border px-3 py-2 text-sm" rows={3} />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-ds border border-border px-4 py-2 text-sm">
            Cancel
          </button>
          <button type="button" onClick={save} className="rounded-ds bg-accent px-4 py-2 text-sm font-semibold text-white hover:bg-accent-hover">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
